import { lazy } from 'react';
import SettingsIcon from '@material-ui/icons/Settings';
import TuneIcon from '@material-ui/icons/Tune';
import PrintIcon from '@material-ui/icons/Print';
import EventIcon from '@material-ui/icons/Event';
import PersonIcon from '@material-ui/icons/Person';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import LayersIcon from '@material-ui/icons/Layers';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import WidgetsIcon from '@material-ui/icons/Widgets';
import DonutLargeIcon from '@material-ui/icons/DonutLarge';
import BuildIcon from '@material-ui/icons/Build';
import ApartmentIcon from '@material-ui/icons/Apartment';
import Evidence_PERMISSIONS from '../constants/evidencePermissionsConstants';

const EvidenceDashboardPage = lazy(() => import('../pages/EvidenceDashboardPage'));
const MyDashboardPage = lazy(() => import('../pages/MyDashboardPage'));
const EvidenceRecords = lazy(() => import('../pages/EvidenceRecords'));
const ApplicationSettings = lazy(() => import('../pages/ApplicationSettings'));
const CodeManagement = lazy(() => import('../pages/CodeManagement'));
const FieldRequirements = lazy(() => import('../pages/FieldRequirements'));
const CheckoutRequestList = lazy(() => import('../pages/CheckoutRequestList'));
const EvidenceDisposalPage = lazy(() => import('../pages/EvidenceDisposalPage'));
const EvidenceAuditPage = lazy(() => import('../pages/EvidenceAuditPage'));
const EvidenceAnalyticsPage = lazy(() => import('../pages/EvidenceAnalyticsPage'));
const ScheduledReports = lazy(() => import('../pages/Scheduledreports'));
const SelectLabels = lazy(() => import('../pages/SelectLabels'));

const evidenceMenus = [
  {
    id: 'myDashboard',
    label: 'My Dashboard',
    path: '/new-evidence/my-dashboard',
    icon: PersonIcon,
    component: MyDashboardPage,
    showInPreferences: true,
  },
  {
    id: 'evidenceDashboard',
    label: 'Evidence Dashboard',
    path: '/new-evidence/dashboard',
    icon: EqualizerIcon,
    component: EvidenceDashboardPage,
    showInPreferences: true,
  },
  {
    id: 'records',
    label: 'Evidence Records',
    path: '/new-evidence/records',
    icon: LayersIcon,
    component: EvidenceRecords,
    permissionLabel: Evidence_PERMISSIONS.Evidence_Record,
    useAccessPermission: false,
    badgeKey: 'waiting',
  },
  {
    id: 'checkoutRequests',
    label: 'Checkout Requests',
    path: '/new-evidence/checkout-request',
    icon: AssignmentTurnedInIcon,
    component: CheckoutRequestList,
    permissionLabel: Evidence_PERMISSIONS.Check_Out_Requests,
    useAccessPermission: false,
    badgeKey: 'checkout',
  },
  {
    id: 'evidenceAudit',
    label: 'Evidence Audit',
    path: '/new-evidence/audit',
    icon: PlaylistAddCheckIcon,
    component: EvidenceAuditPage,
    permissionLabel: Evidence_PERMISSIONS.Evidence_Audit,
    useAccessPermission: false,
    badgeKey: 'audit',
  },
  {
    id: 'evidenceDisposal',
    label: 'Evidence Disposal',
    path: '/new-evidence/disposal',
    icon: WidgetsIcon,
    component: EvidenceDisposalPage,
    permissionLabel: Evidence_PERMISSIONS.Manage_Disposal_Rules,
    useAccessPermission: true,
    badgeKey: 'disposal',
  },
  {
    id: 'evidenceAnalytics',
    label: 'Analytics',
    path: '/new-evidence/analytics',
    icon: DonutLargeIcon,
    component: EvidenceAnalyticsPage,
    showInPreferences: true,
  },
  {
    id: 'configuration',
    label: 'Configuration',
    icon: BuildIcon,
    showInPreferences: false,
    permissionLabel: Evidence_PERMISSIONS.Access_Configuration,
    useAccessPermission: true,
    children: [
      {
        id: 'application-settings',
        label: 'Application Settings',
        path: '/new-evidence/configuration/application-settings',
        icon: ApartmentIcon,
        component: ApplicationSettings,
      },
      {
        id: 'code-management',
        label: 'Code Management',
        path: '/new-evidence/configuration/code-management',
        icon: SettingsIcon,
        component: CodeManagement,
      },
      {
        id: 'field-requirements',
        label: 'Field Requirements',
        path: '/new-evidence/configuration/field-requirements',
        icon: TuneIcon,
        component: FieldRequirements,
      },
      {
        id: 'select-labels',
        label: 'Select Labels',
        path: '/new-evidence/configuration/select-labels',
        icon: PrintIcon,
        component: SelectLabels,
      },
      {
        id: 'scheduled-reports',
        label: 'Scheduled Reports',
        path: '/new-evidence/configuration/scheduled-reports',
        icon: EventIcon,
        component: ScheduledReports,
      },
    ],
  },
];

export default evidenceMenus;
